import {Checkbox as MantineCheckbox, CheckboxProps} from '@mantine/core';
import {
  AdapterProps,
  FieldAdapter,
} from '../field-factory';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $CheckboxAdapterProps = AdapterProps<CheckboxProps>;
export const $CheckboxAdapter: FC<FieldAdapter<$CheckboxAdapterProps>> = ({
  inputProps: {disabled, onChange, ...inputProps},
  control,
}) => {
  const {
    field: {value, onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const {readOnly} = useContext(ReadOnlyContext);

  const _onChange: CheckboxProps['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  return (
    <MantineCheckbox
      error={invalid}
      onChange={_onChange}
      disabled={disabled || readOnly}
      checked={value}
      {...fieldProps}
      {...inputProps}
    />
  );
};